import { render, staticRenderFns } from "./Top5WareneinkaufGesamt.vue?vue&type=template&id=6f58d64a&"
import script from "./Top5WareneinkaufGesamt.vue?vue&type=script&lang=ts&"
export * from "./Top5WareneinkaufGesamt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports